import { render, staticRenderFns } from "./LaboratoryCenter.vue?vue&type=template&id=9ef0556a&scoped=true&"
import script from "./LaboratoryCenter.vue?vue&type=script&lang=js&"
export * from "./LaboratoryCenter.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryCenter.vue?vue&type=style&index=0&id=9ef0556a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef0556a",
  null
  
)

export default component.exports